<template>
  <div>
    <!--eslint-disable-->
    <notifications :max="2" group="bottomright" classes="notification-styling" position="bottom right" />
    <notifications :max="2" group="topcenter" classes="notification-styling" position="top center" />
    <!--eslint-enable-->
  </div>
</template>

<script lang="js">
export default {
  name: 'Debug',
}
</script>

<style lang="postcss">
  .notifications {
  width: 400px !important;
  }
.notification-styling {
  padding: 10px;
  margin: 0 5px 5px;

  font-size: 16px;
  color: #ffffff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;

  & .notification-title {
    text-transform: capitalize;
    font-size: 17px;
  }

  &.warn-notif {
    background: #ffb648;
    border-left-color: #f48a06;
  }

  &.error-notif {
    background: #e54d42;
    border-left-color: #b82e24;
  }

  &.info-notif {
    background: #3eb1f3;
    border-left-color: #08547f;
  }

  &.success-notif {
    background: #68cd86;
    border-left-color: #42a85f;
  }
}
</style>
